import { render } from "./ProfileOrderModal.vue?vue&type=template&id=9bd1db38"
import script from "./ProfileOrderModal.vue?vue&type=script&lang=js"
export * from "./ProfileOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__